import { LoadingPage } from "../LoadingPage/LoadingPage";
import React from "react";

export const GuestPage: React.FC<{
  El: React.LazyExoticComponent<React.FC<{}>>;
}> = ({ El }) => {
  return (
    <React.Suspense fallback={<LoadingPage />}>
      <El />
    </React.Suspense>
  );
};
